import React, { FC } from 'react';
import { Box, Breakpoint, Grid, useMediaQuery, useTheme } from '@mui/material';
import styles from './LayoutComponent.module.scss';
import ContentChild from '../ContentChild/ContentChild';

interface LayoutComponentProps {
    image?: React.ReactNode;
    column?: React.ReactNode;
    children?: React.ReactNode;
    largeBreakpoint?: 'md' | 'lg';
}

const LayoutComponent: FC<LayoutComponentProps> = (props) => {
    const { image, column, children, largeBreakpoint } = props;
    const theme = useTheme();
    const isLargeLayout = useMediaQuery(theme.breakpoints.up(largeBreakpoint as Breakpoint));

    return (
        <Box className={styles.LayoutComponent} data-testid="LayoutComponent">
            <Grid container spacing={4} columnSpacing={{ xs: 0, md: 4 }}>
                <Grid container size={{ xs: 12, md: largeBreakpoint === 'md' ? 4 : 12, lg: 4 }}>
                    <ContentChild sx={{ flex: 1 }}>
                        {isLargeLayout && image}
                        {column}
                    </ContentChild>
                </Grid>
                <Grid
                    container
                    size={{ xs: 12, md: largeBreakpoint === 'md' ? 8 : 12, lg: 8 }}
                    sx={{ flexDirection: 'column' }}
                >
                    {children}
                </Grid>
            </Grid>
        </Box>
    );
};

export default LayoutComponent;

LayoutComponent.defaultProps = {
    image: undefined,
    column: undefined,
    children: undefined,
    largeBreakpoint: 'md',
};
